/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIProvider } from '@/models/api/provider.model'

const resource = {
    main: 'services',
    module: 'providers'
}

export class ProvidersServices {
    public static getProviders () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getProvidersPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getProvidersById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createProviders (params: APIProvider) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editProviders (params: APIProvider) {
        return service.put(`${resource.main}/${resource.module}/${params.providerId}`, params)
    }

    public static deleteProviders (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }

    public static restoreProviders (id: number) {
        return service.put(`${resource.main}/${resource.module}/restore/${id}`)
    }
}
